import React from 'react';
import { motion } from 'framer-motion';
import styles from './PdfRenderer.module.css';
import ContentHeader from '../ContentHeader';

const PdfRenderer = ({ contentDetails, viewerUrl }) => {
  // #toolbar=0&navpanes=0 hides the default browser PDF controls where supported
  const pdfUrl = `${viewerUrl}&#toolbar=0&navpanes=0`;

  return (
    <div className={styles.container}>
      
      <ContentHeader
        title={
          contentDetails?.title ||
          contentDetails?.metadata?.file_metadata?.name ||
          contentDetails?.file_name ||
          'PDF Document'
        }
        url={viewerUrl}
        config={contentDetails?.metadata?.configurations || {}}
      />
      
      <motion.div
        className={styles.pdfWrapper}
        initial={{ opacity: 0, scale: 0.99 }}
        animate={{ opacity: 1, scale: 1 }}
        transition={{ duration: 0.35, ease: [0.16, 1, 0.3, 1], delay: 0.05 }}
      >
        <iframe
          src={pdfUrl}
          title={contentDetails?.title || 'PDF Document'}
          className={styles.iframe}
        ></iframe>
      </motion.div>
    </div>
  );
};

export default PdfRenderer;